import Logo from '../Logo/Logo';
import './Spinner.scss';


const Spinner = ({size}) => {
    return (
        <div className="spinner-container">
            <div className={`spinner-${size}`}>
                <div className="logo">
                    <Logo alt="GeoTicket Logo Spinner" size={size}/>
                </div>
            </div>
        </div>
    );
};

export default Spinner;
